import { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config';

function Profile() {

  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    window.location.href = "/";
  }

  // ✅ Form state
  const [form, setForm] = useState({
    qualification: '',
    experience_years: '',
    skills: '',
    location: '',
    bio: ''
  });

  // ✅ Image states
  const [profilePic, setProfilePic] = useState(null);
  const [existingProfilePic, setExistingProfilePic] = useState(null);

  // ✅ Load profile on page load
  useEffect(() => {
    fetchProfile();
  }, []);

  // ✅ Fetch profile
  const fetchProfile = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/candidates/profile/${user.id}`
      );

      setForm({
        qualification: res.data.qualification || '',
        experience_years: res.data.experience_years || '',
        skills: res.data.skills || '',
        location: res.data.location || '',
        bio: res.data.bio || ''
      });

      setExistingProfilePic(res.data.profile_pic);

    } catch (err) {
      console.log(err);
    }
  };

  // ✅ Handle input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ Save profile
  const handleSave = async () => {

  console.log("SAVE BUTTON CLICKED");

  try {

    const formData = new FormData();

    formData.append("user_id", user.id);
    formData.append("qualification", form.qualification);
    formData.append("experience_years", form.experience_years);
    formData.append("skills", form.skills);
    formData.append("location", form.location);
    formData.append("bio", form.bio);

    if (profilePic) {
      formData.append("profile_pic", profilePic);
    }

    console.log("Sending Request...");

    const res = await axios.post(
      `${API_URL}/candidates/profile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    console.log("SUCCESS:", res.data);

    alert("Profile Saved");

    fetchProfile();

  } catch (err) {

    console.log("ERROR:", err);

    if (err.response) {
      console.log(err.response.data);
    }

    alert("Save Failed");

  }

};
  return (
    <div className="min-h-screen bg-gray-100 flex justify-center items-center">

      <div className="bg-white p-6 rounded shadow w-96">

        <h2 className="text-xl font-bold mb-4">My Profile</h2>

        {/* ✅ Show existing image */}
        {existingProfilePic && (
          <img
            src={`${API_URL.replace('/api', '')}/uploads/${existingProfilePic}`}
            alt="profile"
            className="w-20 h-20 rounded-full mb-3"
          />
        )}

        <input
          name="qualification"
          placeholder="Qualification"
          value={form.qualification}
          onChange={handleChange}
          className="w-full border p-2 mb-2"
        />

        <input
          name="experience_years"
          placeholder="Experience (years)"
          value={form.experience_years}
          onChange={handleChange}
          className="w-full border p-2 mb-2"
        />

        <input
          name="skills"
          placeholder="Skills"
          value={form.skills}
          onChange={handleChange}
          className="w-full border p-2 mb-2"
        />

        <input
          name="location"
          placeholder="Location"
          value={form.location}
          onChange={handleChange}
          className="w-full border p-2 mb-2"
        />

        <textarea
          name="bio"
          placeholder="Bio"
          value={form.bio}
          onChange={handleChange}
          className="w-full border p-2 mb-2"
        />

        <input
          type="file"
          onChange={(e) => setProfilePic(e.target.files[0])}
          className="mb-3"
        />

        <button
          onClick={handleSave}
          className="w-full bg-blue-500 text-white p-2 rounded"
        >
          Save Profile
        </button>

      </div>

    </div>
  );
}

export default Profile;